var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"competitor-info-wrap"},[_c('LeftSide',{on:{"getDetail":_vm.getDetail}}),_c('DetailContent',{attrs:{"detailObj":_vm.detailObj}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }